(function (angular) {
    "use strict";
    angular.module('smartpublic', [
        'ngSanitize',
        'ngMessages',
        'ui.router',
        'ui.bootstrap',
        'ui.bootstrap.showErrors',
        'ui.validate',
        'ui.navbar',
        'vcRecaptcha',
        'ngMap',

        //smartpublic modules
        'smartpublic.config',
        'smartpublic.core',
        'smartpublic.utils'
    
    ]);

})(angular);